import { render, staticRenderFns } from "./order_return_list.vue?vue&type=template&id=39ad224d&scoped=true"
import script from "./order_return_list.vue?vue&type=script&lang=js"
export * from "./order_return_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ad224d",
  null
  
)

export default component.exports